import { render, staticRenderFns } from "./RoomWC.vue?vue&type=template&id=781630f3&scoped=true"
import script from "./RoomWC.vue?vue&type=script&lang=ts"
export * from "./RoomWC.vue?vue&type=script&lang=ts"
import style0 from "./RoomWC.vue?vue&type=style&index=0&id=781630f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781630f3",
  null
  
)

export default component.exports